<template>
    <div>
        <v-icon class="drag-handle-2 mr-4" color="gray">mdi-drag</v-icon>

        <div class="p-4 border criteria-family-block w-100">
            <v-text-field
              outlined
              v-model="family.label"
              placeholder="Question"
              hide-details
              class="w-50"
              :class="{'input-error': family.isDirty }"
              @change="updateFamilyLabel"
            ></v-text-field>

            <v-text-field
              outlined
              v-model="family.description"
              placeholder="Note explicative"
              hide-details
              class="mb-4 w-50"
              @change="updateFamilyDescription"
            ></v-text-field>

            <draggable v-model="criterias"
                       handle=".drag-handle"
                       :options="{
                            animation: 200,
                            ghostClass: 'sortable-ghost',
                            chosenClass: 'sortable-chosen'
                       }"
                       :scroll-sensitivity="200"
                       :force-fallback="true"
                       @start="setCopyCriterias"
                       @change="reorderCriteria">
                <div v-for="criteria in criterias" class="d-flex w-50 mb-3">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-icon class="mr-3" color="primary" @click="createCriteria(criteria)"
                                    v-on="on">
                                add
                            </v-icon>
                        </template>
                        <span>Ajouter une réponse</span>
                    </v-tooltip>

                    <v-icon class="drag-handle mr-4" color="gray">mdi-drag</v-icon>

                    <v-text-field
                      outlined
                      v-model="criteria.label"
                      placeholder="Réponse"
                      hide-details
                      style="padding-top: 0 !important; max-width: 550px"
                      @change="updateCriteria(criteria)"
                      :class="{'input-error': criteria.isDirty }"
                    ></v-text-field>

                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <button class="ml-3 cadh-config-button-icon"
                                    @click="checkIfCriteriaUsed(criteria)"
                                    :disabled="family.criterias.length === 1 || deleteAnswerId === criteria.id ||
                                    deleteCriteriaInProgress"
                                    v-on="on">
                                <v-icon :color="family.criterias.length === 1 || deleteAnswerId === criteria.id ?
                                 '#9a9a9a' : 'error'">
                                    delete
                                </v-icon>
                            </button>
                        </template>
                        <span>Supprimer la réponse</span>
                    </v-tooltip>
                </div>
            </draggable>
        </div>

        <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
                <button class="ml-2 cadh-config-button-icon" @click="deleteFamily(family)" v-on="on">
                    <v-icon color="error">delete</v-icon>
                </button>
            </template>
            <span>Supprimer la question</span>
        </v-tooltip>

        <confirm ref="confirm"></confirm>
    </div>
</template>

<script>
import draggable from "vuedraggable"
import { mapMutations, mapState } from "vuex"
import Confirm from "../../../tools/Confirm.vue"

export default {
    name: "Question",
    props: ["family"],
    components: { Confirm, draggable },
    data() {
        return {
            deleteAnswerId: null,
            copyCriterias: [],
        }
    },
    methods: {
        ...mapMutations("cadhConfig", ["setCurrentStep", "setCadhConfig"]),
        updateFamilyLabel() {
            let payload = {
                cadhCriteriaFamilyId: this.family.id,
                label: this.family.label,
            }

            this.$store.dispatch("cadhConfig/updateCriteriaFamilyLabel", payload)
        },
        updateFamilyDescription() {
            let payload = {
                cadhCriteriaFamilyId: this.family.id,
                description: this.family.description,
            }

            this.$store.dispatch("cadhConfig/updateCriteriaFamilyDescription", payload)
        },
        updateCriteria(criteria) {
            let payload = {
                cadhCriteriaId: criteria.id,
                label: criteria.label,
                order: criteria.order,
            }

            this.$store.dispatch("cadhConfig/updateCriteria", payload)
        },
        deleteFamily(family) {
            if (!this.checkFamilyIsUsed(family)) {
                this.$refs.confirm.open("Attention", "Voulez-vous vraiment supprimer cette question ?",
                  { color: "red" }).then((confirm) => {
                    if (confirm) {
                        this.$store.dispatch("cadhConfig/deleteCriteriaFamily", family.id)
                    }
                })
            } else {
                this.$refs.confirm.open("Attention",
                  "Cette question a des réponses associées à des offres, des options ou des informations." +
                  " Êtes-vous sûre de vouloir la supprimer ?",
                  { color: "red" }).then((confirm) => {
                    if (confirm) {
                        this.$store.dispatch("cadhConfig/deleteCriteriaFamily", family.id)
                    }
                })
            }
        },
        checkFamilyIsUsed(family) {
            let used = false

            family.criterias.forEach(criteria => {
                if (criteria.offers.length > 0 || criteria.options.length > 0 || criteria.informations.length > 0) {
                    used = true
                }
            })

            return used
        },
        createCriteria(criteria) {
            let order = criteria.order + 1

            let payload = {
                configId: this.cadhConfig.id,
                cadhCriteriaFamilyId: this.family.id,
                order: order,
                label: "",
            }

            this.$store.dispatch("cadhConfig/createCriteria", payload)
        },
        checkIfCriteriaUsed(criteria) {
            if (criteria.offers.length === 0 && criteria.options.length === 0 && criteria.informations.length === 0) {
                this.deleteCriteria(criteria.id)
            } else {
                this.$refs.confirm.open("Attention", "Cette réponse est associée à au moins un offre, " +
                  "une option ou une information, êtes-vous sûr de vouloir la supprimer ?",
                  { color: "red" }).then((confirm) => {
                    if (confirm) {
                        this.deleteCriteria(criteria.id)
                    }
                })
            }
        },
        async deleteCriteria(id) {
            this.deleteAnswerId = id

            await this.$store.dispatch("cadhConfig/deleteCriteria", id)

            this.deleteAnswerId = null
        },
        setCopyCriterias(event) {
            this.copyCriterias = JSON.parse(JSON.stringify(this.criterias))
        },
        reorderCriteria(event) {
            if (event.moved) {
                const pointerType = event.moved.newIndex !== this.criterias.length - 1 ? "before" : "after"
                const moveObject = event.moved.element.id
                const pointerId = this.copyCriterias[event.moved.newIndex].id

                this.$store.dispatch("cadhConfig/reorderList", [
                    "cadh_criterias",
                    this.cadhConfig.id,
                    pointerId,
                    pointerType,
                    moveObject,
                    "cadh_criteria_family_id",
                    event.moved.element.cadh_criteria_family_id,
                ]).then(res => {
                    this.criterias = res.body.data.items
                })
            }
        },
    },
    computed: {
        ...mapState("cadhConfig", ["cadhConfig", "deleteCriteriaInProgress"]),
        criterias: {
            get() {
                return this.family.criterias
            },
            set(value) {
                this.$store.commit("cadhConfig/updateFamilyCriterias", [value, this.family.id])
            },
        },
    },
}
</script>

